import { createFileRoute } from "@tanstack/react-router";
import { StakingAssetPage } from "../../features/staking/pages/staking-asset-page";
import { assetRouteLoader } from "../../features/staking/utils/route-loaders";

// Index page for a specific staking asset (e.g., /staking/eth)
export const Route = createFileRoute("/_layout/staking/$asset/")({
  loader: assetRouteLoader,
  component: StakingAssetPage,
});
